import React from "react";
import { createPortal } from "react-dom";

export const LogoutConfirmDialog = ({
  open,
  busy,
  onCancel,
  onConfirm,
  testIdPrefix,
}) => {
  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100] bg-[#1E2A24]/65"
      role="dialog"
      aria-modal="true"
      aria-labelledby={`${testIdPrefix}-logout-title`}
      data-testid={`${testIdPrefix}-logout-modal`}
    >
      <div
        className={[
          "fixed left-1/2 top-1/2 z-[101] w-[calc(100vw-2rem)] max-w-[320px]",
          "border border-[#E2DCD2] bg-white p-5 shadow-2xl",
        ].join(" ")}
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <h2
          id={`${testIdPrefix}-logout-title`}
          className="font-serif text-xl font-semibold text-[#1E2A24]"
        >
          Are you sure you want to logout?
        </h2>
        <p className="mt-2 text-sm text-[#64748B]">
          You will need to sign in again to access your account.
        </p>
        <div className="mt-5 grid grid-cols-2 gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className={[
              "border border-[#E2DCD2] px-3 py-2 text-sm font-semibold text-[#64748B]",
              "hover:text-[#1E2A24] disabled:opacity-50",
            ].join(" ")}
            data-testid={`${testIdPrefix}-logout-cancel`}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={[
              "bg-[#2D5A47] px-3 py-2 text-sm font-semibold text-white",
              "hover:bg-[#214435] disabled:opacity-50",
            ].join(" ")}
            data-testid={`${testIdPrefix}-logout-confirm`}
          >
            {busy ? "Logging out…" : "Yes, Logout"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};